import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grow } from "@mui/material";
import { ButtonBase } from "@mui/material";
import bannersplash from "assets/bannersplash.png";
import signaturePng from "assets/signature.png";
import whiteJersey from "assets/white-jersey.png";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { COLOR_PRIMARY_DARKER, COLOR_SECONDARY, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK, FONT_FAMILY_KNOCKOUT_JUNIOR } from "helpers/FONT";
import { SPACING } from "helpers/spacings";
import React, { useState } from "react";
import { useComponentSize } from "react-use-size";

export default function IntroBanner({ title, description, learnMoreDialogContent }) {
  const [dialogOpen, dialogOpenSet] = useState(false);
  const size = useComponentSize();

  return (
    <div
      ref={size.ref}
      style={{
        padding: 20,
        backgroundColor: COLOR_PRIMARY_DARKER,
        color: COLOR_WHITE,
        backgroundImage: `url(${bannersplash})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: FONT_FAMILY_GRAPHIK,
        fontSize: "0.9em",
        fontWeight: 400,
        lineHeight: 1.5,
        display: "flex",
        flexFlow: "column nowrap",
        gap: 10,
      }}
    >
      <div
        style={{ width: `calc(100vw - ${SPACING} * 2)`, maxWidth: MAX_CONTENT_WIDTH, margin: `${SPACING} auto 0 auto` }}
      >
        <div
          style={{
            fontSize: "3em",
            fontFamily: FONT_FAMILY_KNOCKOUT_JUNIOR,
            fontWeight: 300,
          }}
        >
          {title}
        </div>
        <div
          style={{
            fontSize: "0.9em",
          }}
        >
          {description}
        </div>
        <div>
          <ButtonBase
            style={{ color: COLOR_SECONDARY, fontFamily: FONT_FAMILY_GRAPHIK }}
            onClick={() => dialogOpenSet(true)}
          >
            See how it works
          </ButtonBase>
        </div>
      </div>
      <Dialog
        open={dialogOpen}
        onClose={() => dialogOpenSet(false)}
        TransitionComponent={Grow}
        TransitionProps={{ easing: "ease-in-out", timeout: 300 }}
        maxWidth="md"
      >
        <div style={{ display: "flex", flexFlow: "row nowrap" }}>
          <div style={{ display: "flex", flexFlow: "column nowrap" }}>
            <DialogTitle style={{ fontFamily: FONT_FAMILY_KNOCKOUT_JUNIOR, textTransform: "uppercase", fontSize: 24 }}>
              Plays of the Week
            </DialogTitle>
            <DialogContent
              style={{
                fontSize: "0.9em",
                lineHeight: "1.5",
                fontFamily: FONT_FAMILY_GRAPHIK,
              }}
            >
              {learnMoreDialogContent}
              <p>
                <img src={signaturePng} alt="Glory League" />
              </p>
              <p>Glory League Team</p>
            </DialogContent>
          </div>
          {size.width > 500 && <img src={whiteJersey} alt="White Jersey" />}
        </div>
        <DialogActions>
          <Button size="large" variant="contained" color="secondary" onClick={() => dialogOpenSet(false)}>
            Get Started
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
